type LeaveGuard = (proceed: () => void) => void;

let leaveGuard: LeaveGuard | null = null;

export function registerDraftLayerLeaveGuard(guard: LeaveGuard | null) {
  leaveGuard = guard;
}

/**
 * Ask the open draft-layer screen before leaving. Proceeds immediately when
 * none is open.
 */
export function requestDraftLayerLeave(proceed: () => void) {
  if (!leaveGuard) {
    proceed();
    return;
  }
  leaveGuard(proceed);
}
